<script setup lang="ts">
import { AtomText, SatButton } from "@chatfood/design-system";
import { bemBuilder } from "@chatfood/core-utils";
import { useModalHubStore } from "../modal-hub";
import { useLocale } from "~/composables/use-locale";
import { CrossSellItems } from "~/components/cross-sell-items";

import { useNavigation } from "~/composables/use-navigation";

const css = bemBuilder("cross-sell-list");

const { t } = useLocale();
const modalHub = useModalHubStore();
const { push } = useNavigation();

const onCheckout = async () => {
  await push("checkout", {});
  modalHub.hideCrossSellList();
};

const onCrossSellReady = (itemsFound: number) => {
  if (itemsFound > 0) {
    return;
  }

  onCheckout();
};
</script>

<template>
  <div :class="css('')">
    <AtomText type="subtitle" tag="div" :class="css('header')">
      {{ t("components.cross_sell_list.title") }}
    </AtomText>
    <div :class="css('content')">
      <CrossSellItems variant="list" @loaded="onCrossSellReady" />
    </div>
    <div :class="css('footer')">
      <SatButton
        theme="filled"
        variant="primary"
        wide
        size="large"
        @click="onCheckout"
      >
        {{ t("components.cross_sell_list.cta") }}
      </SatButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cross-sell-list {
  width: 576px;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  @media (width > $breakpoint-sm) {
    max-height: 90vh;
  }

  &__header {
    padding-inline: var(--spacing-lg);
    padding-top: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }

  &__content {
    position: relative;
    overflow: auto;
    padding-inline: var(--spacing-lg);
  }

  &__footer {
    padding-inline: var(--spacing-lg);
    padding-block: var(--spacing-lg);
    background-color: var(--color-base-100);
    position: sticky;
    bottom: 0;
    left: 0;

    @media (width > $breakpoint-sm) {
      background-color: unset;
    }
  }
}
</style>
